import { gql } from '@apollo/client';

export const ADDRESS_CREATE = gql`
    mutation createAddress( $input: CreateAddressInput! ) {
        createAddress( input: $input ) {
            id
            label
            name
            addressLine1
            addressLine2
            locality
            administrativeArea
            postalCode
            country {
                id
                code
                name
            }
            comment
            createdAt
            updatedAt
        }
    }
`;

export default ADDRESS_CREATE;
